import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Account() {
  const { user, reload } = useAuth();
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [phone, setPhone] = useState(user?.phone || "");
  const [name, setName] = useState(user?.name || "");
  const [pBusy, setPBusy] = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault();
    setPBusy(true);
    try {
      await api.patch("/auth/me", { name, phone });
      toast.success("Profilo aggiornato");
      await reload();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally { setPBusy(false); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw });
      toast.success("Password aggiornata");
      setCurrent(""); setPw(""); setPw2("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  if (!user) return null;

  return (
    <div className="max-w-3xl mx-auto px-5 py-10 md:py-16">
      <div className="text-xs tracking-widest uppercase text-primary">Il mio account</div>
      <h1 className="font-display text-3xl md:text-5xl mt-2">Impostazioni</h1>

      <form onSubmit={saveProfile} className="mt-8 bg-white border border-border rounded-xl p-6 md:p-8 space-y-4">
        <div className="font-display text-2xl">Profilo</div>
        <div className="grid md:grid-cols-2 gap-4">
          <div><Label>Nome</Label><Input required value={name} onChange={(e)=>setName(e.target.value)} className="mt-1" data-testid="account-name" /></div>
          <div><Label>Email</Label><Input value={user.email} disabled className="mt-1" /></div>
          <div><Label>Telefono</Label><Input value={phone} onChange={(e)=>setPhone(e.target.value)} className="mt-1" data-testid="account-phone" /></div>
        </div>
        <Button type="submit" disabled={pBusy} className="rounded-full" data-testid="account-save">{pBusy ? "Salvataggio..." : "Salva profilo"}</Button>
      </form>

      <form onSubmit={changePw} className="mt-6 bg-white border border-border rounded-xl p-6 md:p-8 space-y-4">
        <div className="font-display text-2xl">Cambia password</div>
        <div>
          <Label>Password attuale</Label>
          <Input type="password" required value={current} onChange={(e)=>setCurrent(e.target.value)} className="mt-1" data-testid="account-current-pw" />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div><Label>Nuova password (min. 6)</Label><Input type="password" required minLength={6} value={pw} onChange={(e)=>setPw(e.target.value)} className="mt-1" data-testid="account-new-pw" /></div>
          <div><Label>Conferma nuova password</Label><Input type="password" required minLength={6} value={pw2} onChange={(e)=>setPw2(e.target.value)} className="mt-1" data-testid="account-new-pw2" /></div>
        </div>
        <Button type="submit" disabled={busy} className="rounded-full" data-testid="account-change-pw">{busy ? "Aggiornamento..." : "Aggiorna password"}</Button>
      </form>
    </div>
  );
}
